module.exports = new __parcel__URL__("scratch03.acbc8403.mp3").toString();